import { render, staticRenderFns } from "./NP.vue?vue&type=template&id=70e48cb2&scoped=true&"
import script from "./NP.vue?vue&type=script&lang=js&"
export * from "./NP.vue?vue&type=script&lang=js&"
import style0 from "./NP.vue?vue&type=style&index=0&id=70e48cb2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e48cb2",
  null
  
)

export default component.exports